// src/components/BottomNav.tsx
import React from "react";
import { Link } from "react-router-dom";

type Props = {
  active?: "dashboard" | "library" | "upload" | "profile" | string;
  /**
   * Optional callback — if provided, BottomNav will call onNavigate(tabId)
   * instead of using Link navigation. This is convenient when you keep
   * a single-page view state (DemoDashboard).
   */
  onNavigate?: (tabId: "dashboard" | "library" | "upload" | "profile") => void;
};

const tabs = [
  { id: "dashboard", label: "Dashboard", icon: "🏠", path: "/dashboard" },
  { id: "library", label: "Library", icon: "📁", path: "/library" },
  { id: "upload", label: "Upload", icon: "⬆️", path: "/upload" },
  { id: "profile", label: "Profile", icon: "👤", path: "/profile" },
];

export default function BottomNav({ active = "dashboard", onNavigate }: Props) {
  return (
    <nav
      className="
        fixed bottom-0 left-0 right-0 z-50 md:hidden
        bg-black/60 backdrop-blur
        border-t border-white/10
        flex justify-around py-2
        pb-[env(safe-area-inset-bottom)]
        shadow-[0_-4px_12px_rgba(0,0,0,0.25)]
      "
    >
      {tabs.map((tab) => {
        const isActive = active === tab.id;
        const content = (
          <div
            className={`flex flex-col items-center text-xs gap-1 px-4 py-1 rounded-lg transition-colors ${
              isActive ? "text-white bg-white/10" : "text-gray-300"
            }`}
          >
            <span className="text-xl">{tab.icon}</span>
            <span className="font-medium">{tab.label}</span>
          </div>
        );

        if (onNavigate) {
          return (
            <button
              key={tab.id}
              onClick={() => onNavigate(tab.id as any)}
              aria-current={isActive ? "page" : undefined}
            >
              {content}
            </button>
          );
        }

        // fallback: Links (for pages where you want route navigation)
        return (
          <Link key={tab.id} to={tab.path} aria-current={isActive ? "page" : undefined}>
            {content}
          </Link>
        );
      })}
    </nav>
  );
}
